module.exports = __webpack_public_path__ + "static/img/ninja1.c927b8c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ninja1.jpeg
// module id = zqhV
// module chunks = 0